import React from "react";
import FromToRangeInput from "../input/FromToRangeInput";
import { useDispatch, useSelector } from "react-redux";
import { removeFromFilter, updateFilter } from "../../store/slices/filterSlice";

const CutPolSym = () => {
  const cut = [
    { lable: "-", value: "-" },
    { lable: "Ideal", value: "IDEAL" },
    { lable: "8X", value: "8X" },
    { lable: "EX", value: "EXCELLENT" },
    { lable: "VG", value: "VERY GOOD" },
    { lable: "G", value: "GOOD" },
  ];

  const pol = [
    { lable: "GD", value: "GD" },
    { lable: "EX", value: "EXCELLENT" },
    { lable: "VG", value: "VERY GOOD" },
    { lable: "G", value: "GOOD" },
  ];

  const sym = [
    { lable: "EX", value: "EXCELLENT" },
    { lable: "VG", value: "VERY GOOD" },
    { lable: "G", value: "GOOD" },
  ];
  const dispatch = useDispatch();
  const filterSelect = useSelector((state) => state?.filter);
  return (
    <div className="cut-pol-sym-container gap-3 mt-3">
      <div className="w-100">
        <label className="filter-main-label">Cut</label>
        <div className="filter-bg-container cut-range range-outer-container">
          {cut.map((item) => {
            return (
              <div
                className={`range-item ${
                  filterSelect?.cut?.includes(item?.value) ? "active" : ""
                }`}
                onClick={() =>
                  filterSelect?.cut?.includes(item?.value)
                    ? dispatch(
                        removeFromFilter({ key: "cut", value: item.value })
                      )
                    : dispatch(updateFilter({ key: "cut", value: item.value }))
                }
              >
                {item.lable}
              </div>
            );
          })}
        </div>
      </div>
      <div className="w-100">
        <label className="filter-main-label">Polish</label>
        <div className="filter-bg-container pol-range range-outer-container">
          {pol.map((item) => {
            return (
              <div
                className={`range-item ${
                  filterSelect?.polish?.includes(item.value) ? "active" : ""
                }`}
                onClick={() =>
                  filterSelect?.polish?.includes(item?.value)
                    ? dispatch(
                        removeFromFilter({ key: "polish", value: item.value })
                      )
                    : dispatch(
                        updateFilter({ key: "polish", value: item.value })
                      )
                }
              >
                {item.lable}
              </div>
            );
          })}
        </div>
      </div>
      <div className="w-100">
        <label className="filter-main-label">Symmetry</label>
        <div className="filter-bg-container sym-range range-outer-container">
          {sym.map((item) => {
            return (
              <div
                className={`range-item ${
                  filterSelect?.symmetry?.includes(item.value) ? "active" : ""
                }`}
                onClick={() =>
                  filterSelect?.symmetry?.includes(item?.value)
                    ? dispatch(
                        removeFromFilter({ key: "symmetry", value: item.value })
                      )
                    : dispatch(
                        updateFilter({ key: "symmetry", value: item.value })
                      )
                }
              >
                {item.lable}
              </div>
            );
          })}
        </div>
      </div>
      <div className="cut-pol-sym-range">
        <FromToRangeInput
          mainContainerClass={"cut-pol-sym-inputs"}
          mainLabel={"Ratio"}
          isDecimal
          fromValue={filterSelect?.minRange}
          toValue={filterSelect?.maxRange}
          onMinChange={(e) =>
            dispatch(
              updateFilter({ key: "minRange", value: Number(e.target.value) })
            )
          }
          onMaxChange={(e) =>
            dispatch(
              updateFilter({ key: "maxRange", value: Number(e.target.value) })
            )
          }
        />
      </div>
    </div>
  );
};

export default CutPolSym;
